module.exports = __webpack_public_path__ + "media/images/banner_dashboard-4b3ff8609016bc35709c6c14ac69c362.jpg";